import {useContext} from 'react'
import {Link} from 'react-router-dom'
import ManagersContext from '../../containers/ManagersContext'
import funride from '../../lib/funride/funride.module.less'
import {iTechNote} from '../../managers/interfaces'
import {TECH_CATEGORY, TECH_DISPLAY} from '../../types'

interface iInnerPageTech {
  display: TECH_DISPLAY,
  value: string
}
export default function InnerPageTech (props: iInnerPageTech) {
  switch (props.display) {
  case TECH_DISPLAY.topic:
    return <ListSingle topic={props.value}/>
  case TECH_DISPLAY.list:
    return <ListAll/>
  case TECH_DISPLAY.category:
    return <ListCategory categoryKey={props.value as string}/>
  default:
    return <ListAll/>
  }
}
const ListSingle = (props: {topic: string}) => {
  const {techNotesManager} = useContext(ManagersContext)
  return (
    <div>
      <header>
        <h1>Tech Notes: <span className={funride.techTitle}>{props.topic}</span></h1>
        <p>Notes on the topic of <span className={funride.techTitle}>{props.topic}</span>.</p>
      </header>
      <iframe
        id={funride.tech}
        src={techNotesManager.get(props.topic)!.url}
      />
    </div>
  )
}
const ListAll = () => {
  const {techNotesManager} = useContext(ManagersContext)
  return (
    <div>
      <header>
        <h1>Tech Notes</h1>
        <p>
          These are notes I keep on the technologies I support.
        </p>
      </header>
      <ul className={funride.singleLines}> {
        techNotesManager.getAllAlphabetical().map((tech:iTechNote, i:number) => (
          <li style={{fontSize: '1.2em'}} key={`tech_${i}`}><Link to={tech.path}>{tech.title}</Link></li>
        ))
      }
      </ul>
    </div>
  )
}
const ListCategory = (props: { categoryKey: string }) => {
  const {techNotesManager} = useContext(ManagersContext)
  // props.value will be a key for TECH_CATEGORY
  return (
    <div>
      <header>
        <h1>Tech Notes</h1>
        <p>
          {/* eslint-disable @typescript-eslint/no-explicit-any */}
          These are notes relating to the topic of {(TECH_CATEGORY as any)[props.categoryKey]}
        </p>
      </header>
      <ul className={funride.singleLines}> {
        techNotesManager.getAllByCategory(props.categoryKey).map((tech:iTechNote, i:number) => (
          <li style={{fontSize: '1.2em'}} key={`tech_${i}`}><Link to={tech.path}>{tech.title}</Link></li>
        ))
      }
      </ul>
    </div>
  )
}
